import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _ from 'lodash';
export const removeNavLinkIcon = _ref => {
  let navLink = _ref.navLink,
    rest = _objectWithoutProperties(_ref, ["navLink"]);
  if (!navLink) return rest;
  return _objectSpread({}, rest, {
    navLink: _.omit(navLink, 'icon')
  });
};
export const shouldShowIcons = routes => {
  const showOnNavBarRoutes = _filterInstanceProperty(routes).call(routes, route => _.get(route, 'showOnNavBar', true));
  const hasNavLinkRoutes = _everyInstanceProperty(showOnNavBarRoutes).call(showOnNavBarRoutes, ({
    navLink
  }) => navLink);
  return hasNavLinkRoutes && _everyInstanceProperty(showOnNavBarRoutes).call(showOnNavBarRoutes, ({
    navLink: {
      icon
    }
  }) => icon);
};